import {AddDebtsFormFields, UpdateDebtFormFields} from "../models/debts/debt";
import responseMessagesService from "./response-messages-service";

class DebtsService {

    constructor() {
    }

    async add(d: AddDebtsFormFields): Promise<[status: boolean, title: string, messages: string[]]> {
        let response = await fetch("/api/v1/private/debts/", {
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({
                propertyId: d.propertyId,
                systemType: d.systemType,
                type: d.type,
                sum: parseFloat(d.sum),
                comment: d.comment
            }),
        })

        if (response.status === 200) {
            return [true, "Данные успешно сохранены!", []]
        } else {
            let respJson = await response.json()
            let [title, messages] = responseMessagesService.getErrorMessage(respJson)
            return [false, title, messages]
        }
    }

    async update(d: UpdateDebtFormFields): Promise<[status: boolean, title: string, messages: string[]]> {
        let data = {
            propertyId: d.propertyId,
            systemType: d.systemType,
            type: d.type,
            sum: parseFloat(d.sum),
            // sum: d.sum,
            comment: d.comment,
            lastPaidMeterData: parseFloat(d.lastPaidMeterData),
            // lastPaidMeterData: d.lastPaidMeterData,
            connectionId: d.connectionId,
            // electricityKwhRate: d.electricityKwhRate,
            electricityKwhRate: parseFloat(d.electricityKwhRate),
        }

        console.log(data);

        let response = await fetch("/api/v1/private/debts/"+d.id, {
            headers: {
                "Content-Type": "application/json",
            },
            method: "PUT",
            body: JSON.stringify(data),
        })

        if (response.status === 200) {
            return [true, "Данные успешно сохранены!", []]
        } else {
            let respJson = await response.json()
            let [title, messages] = responseMessagesService.getErrorMessage(respJson)
            return [false, title, messages]
        }
    }

    async delete(id: number): Promise<any> {
        let response = await fetch("/api/v1/private/debts/"+id, {
            headers: {
                "Content-Type": "application/json",
            },
            method: "DELETE",
            body: "",
        })

        if (response.status === 200) {
            // let respJson = await response.json()
            return true
        } else {
            return false
        }
    }



}


let debtsService = new DebtsService()
export default debtsService;